import { useEffect } from 'react';

// Replace YOUR_PUBLISHER_ID with your actual ca-pub-XXXXXXXXXXXXXXXX
const PUBLISHER_ID = 'ca-pub-XXXXXXXXXXXXXXXX';

export default function AdBanner({ slot, format = 'auto', style = {} }) {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.log('AdSense error:', e);
    }
  }, []);

  // Show placeholder in development
  if (process.env.NODE_ENV === 'development') {
    return (
      <div className="ad-slot" style={style}>
        AdSense Ad Slot: {slot} ({format})
      </div>
    );
  }

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block', ...style }}
      data-ad-client={PUBLISHER_ID}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive="true"
    />
  );
}
